import { writable } from "svelte/store";

export const state = writable(0);
export const seed = writable(1);
